import { Box } from '@branch-messenger/willow-ui'
import styled from 'styled-components'

export const PersonalInfoFormContainer = styled(Box).attrs({
  $display: 'flex',
  $direction: 'column',
  $align: 'flex-start',
  $gap: 6,
  as: 'form',
})`
  max-width: 560px;
`
